export default function Footer() {
  return (
    <footer className="relative w-full bg-offwhite paper-texture border-t border-secondary-200/25">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10 md:gap-8">
          {/* Brand column */}
          <div className="flex flex-col gap-4">
            <div>
              <h3 className="font-heading text-lg text-graphite font-medium tracking-[0.15em]">
                DRA. NATHÁLIA POSSO
              </h3>
              <p className="font-body text-[10px] text-secondary-500 tracking-[0.3em] mt-1">
                GINECOLOGIA
              </p>
            </div>
            <p className="font-body text-xs text-graphite/45 font-light leading-relaxed max-w-xs">
              Ginecologia humanizada e personalizada para mulheres que buscam excelência, conforto e respeito.
            </p>
            <div className="flex items-center gap-2">
              <span className="font-body text-[10px] text-secondary-500">CRM 14200</span>
              <span className="text-secondary-300 text-[10px]">|</span>
              <span className="font-body text-[10px] text-secondary-500">RQE 8571</span>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex flex-col gap-3">
            <p className="font-body text-[10px] text-graphite/75 tracking-[0.2em] uppercase font-medium mb-1">
              Navegação
            </p>
            {[
              { label: 'Sobre', id: 'sobre' },
              { label: 'Áreas de Atuação', id: 'areas' },
              { label: 'Clínica', id: 'clinica' },
              { label: 'Depoimentos', id: 'depoimentos' },
              { label: 'FAQ', id: 'faq' },
            ].map((link) => (
              <button
                key={link.id}
                onClick={() => {
                  const el = document.getElementById(link.id);
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="font-body text-xs text-graphite/45 hover:text-graphite hover:translate-x-1 transition-all duration-300 text-left whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-3">
            <p className="font-body text-[10px] text-graphite/75 tracking-[0.2em] uppercase font-medium mb-1">
              Contato
            </p>
            <a
              href="tel:+5585984293412"
              className="font-body text-xs text-graphite/45 hover:text-graphite hover:translate-x-1 transition-all duration-300 whitespace-nowrap"
            >
              (85) 98429-3412
            </a>
            <p className="font-body text-xs text-graphite/45 font-light">
              Duets Office Towers · Torre Sul
              <br />
              Rua Dr. Gilberto Studart, 55 · Sl 610
              <br />
              Cocó · Fortaleza - CE
            </p>
            <p className="font-body text-xs text-graphite/45 font-light">
              Seg a Sex · 8h às 18h
            </p>
          </div>

          {/* Social */}
          <div className="flex flex-col gap-3">
            <p className="font-body text-[10px] text-graphite/75 tracking-[0.2em] uppercase font-medium mb-1">
              Redes Sociais
            </p>
            <a
              href="https://instagram.com/dranathaliaposso"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-body text-xs text-graphite/45 hover:text-graphite hover:translate-x-1 transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-instagram-line text-sm" />
              Instagram
            </a>
            <a
              href="https://api.whatsapp.com/send/?phone=5585984293412&text=Ol%C3%A1%21+Gostaria+de+informa%C3%A7%C3%B5es+sobre+procedimentos+e+consultas+com+a+Dra+Nathalia&type=phone_number&app_absent=0"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="font-body text-xs text-graphite/45 hover:text-graphite hover:translate-x-1 transition-all duration-300 flex items-center gap-2 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-sm" />
              WhatsApp
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-secondary-200/25 mt-12 md:mt-16 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-[11px] text-secondary-500 font-light">
            &copy; {new Date().getFullYear()} Dra. Nathália Posso. Todos os direitos reservados.
          </p>
          <p className="font-body text-[11px] text-secondary-400 font-light">
            Ginecologia com acolhimento e ciência.
          </p>
        </div>
      </div>
    </footer>
  );
}